import React from 'react';
import { Divider } from 'semantic-ui-react';
import './index.scss';

const creditScoreExplainer = [
  {
    range: '300 - 516',
    color: '#DB2829',
    description: 'Very Bad',
  },
  {
    range: '517 - 551',
    color: '#FF5630',
    description: 'Bad',
  },
  {
    range: '552 - 586',
    color: '#D77501',
    description: 'Fair',
  },
  {
    range: '587 - 631',
    color: '#00E485',
    description: 'Good',
  },
  {
    range: '632 - 850',
    color: '#029357',
    description: 'Excellent',
  },
];

const SaveScoreBandPopup = () => {
  return (
    <div className="loan-request-info-popup__body__requester-info__popup">
      <div className="loan-request-info-popup__body__requester-info__popup__title">
        SAVE Score Band
      </div>
      <Divider />
      <div className="loan-request-info-popup__body__requester-info__popup__body">
        {creditScoreExplainer.map(({ range, color, description }) => {
          return (
            <div className="loan-request-info-popup__body__requester-info__popup__body__item">
              <div
                className="loan-request-info-popup__body__requester-info__popup__body__item__color"
                style={{
                  backgroundColor: `${color}`,
                }}
              />
              <div className="loan-request-info-popup__body__requester-info__popup__body__item__data">
                <span className="loan-request-info-popup__body__requester-info__popup__body__item__score">
                  {range}
                </span>
                <span className="loan-request-info-popup__body__requester-info__item__phone">
                  {description}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SaveScoreBandPopup;
